import React from "react";
import ".//Styles/EchiPopup.css";
import { CheckCircle2, XCircle, AlertTriangle, Info } from "lucide-react";

export type PopupType = "success" | "error" | "warning" | "notice";

interface GeneralPopupProps {
  isOpen: boolean;
  onClose: () => void;
  type: PopupType;
  title: string;
  message: string;
}

const popupConfig = {
  success: {
    Icon: CheckCircle2,
    className: "echi-popup-success",
  },
  error: {
    Icon: XCircle,
    className: "echi-popup-error",
  },
  warning: {
    Icon: AlertTriangle,
    className: "echi-popup-warning",
  },
  notice: {
    Icon: Info,
    className: "echi-popup-notice",
  },
};

export const GeneralPopupComponent: React.FC<GeneralPopupProps> = ({
  isOpen,
  onClose,
  type,
  title,
  message,
}) => {
  if (!isOpen) return null;

  const { Icon, className } = popupConfig[type];

  return (
    <div className="echi-popup-overlay" onClick={onClose}>
      <div
        className={`echi-popup-container ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        <Icon size={48} className="echi-popup-icon" />
        <h2 className="echi-popup-title">{title}</h2>
        <p className="echi-popup-message">{message}</p>
        <button className="echi-popup-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};
